
import React from 'react';
import { Link } from 'react-router-dom'; 
import styles from './banner.module.css';

const Banner = () => {
  return (
    <div className={styles.banner}>
      <div className={styles.container}>
        <div className={styles.navigation}>
          <Link to="/" className={styles.darkText}>
            Главная
          </Link>
          <span className={styles.dash}> - </span>
          <span className={styles.whiteText}>Каталог</span>
        </div>
        <h1 className={styles.title}>Каталог</h1>
      </div>
    </div>
  );
};

export default Banner;
